import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiLmLg030 {

  // API Name
  export const name: string = 'ApiLmLg030'

  // GET parameters
  export namespace Post {
    // API Request
    export interface Request {
      body: {
        screenId: string
        actionId: string
        statusId: string
        message: string
        learningTime: string | null
      }
    }

    // API Response
    export interface Response {}
  }

  // API Path
  export const path: string = '/ta/sendLog'

  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    public post<R>(
      params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Post.Response = {}

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
